module.exports = __webpack_public_path__ + "img/chofu_all_off.90ffe424.svg";